import type { VirtualFile } from "@pdfking/pdfengine"
import { FileContentGUID } from "@pdfking/pdfengine"
import { ArrayToIterable, StringHash } from "@pdfking/tfunc"
import { Zip } from "@pdfking/tfunc"
import { BlobUrl } from "@pdfking/workflow/actions/pdfengine/BlobUrl"
import { ZipFiles } from "@pdfking/workflow/actions/pdfengine/Functions"

import download_url from "../actions/download_url"

export default async (
  mapping: Record<string, VirtualFile>,
  filename?: string
): Promise<void> => {
  const names = Object.keys(mapping)
  const files = Object.values(mapping)

  let file: VirtualFile
  let name: string

  if (files.length === 1) {
    name = names[0]
    file = files[0]
  } else {
    const hash = await StringHash(
      ArrayToIterable(names, files.map(FileContentGUID))
    )
    name = filename || `${hash.toString(36)}.zip`
    file = await ZipFiles(Zip(names, files), hash)
  }
  return download_url(await BlobUrl(file), name)
}
